var COCHRANE_ORGANIZATION_ID, DO, Outcome, OutcomesHelper, Qualities, formatters, getCapitalizedValueForCochrane, isInteger, mediator, numberToLocaleString, statisticalUtils, utils;

COCHRANE_ORGANIZATION_ID = require('lib/archie_helper').COCHRANE_ORGANIZATION_ID;

DO = require('models/outcome/diagnostic_outcomes');

isInteger = require('lodash').isInteger;

mediator = require('mediator');

Outcome = require('models/outcome');

OutcomesHelper = require('lib/outcomes_helper');

Qualities = require('models/outcome/qualities');

statisticalUtils = require('lib/statistical_utils');

utils = require('base/lib/utils');

getCapitalizedValueForCochrane = require('lib/view_helper_utils').getCapitalizedValueForCochrane;

numberToLocaleString = function(number) {
  if (!$.isNumeric(number)) {
    return '--';
  }
  number = Number(number);
  if (mediator.activeWorkspace === COCHRANE_ORGANIZATION_ID) {
    if (isInteger(number) && number < 10000) {
      return number.toString();
    } else {
      return number.toLocaleString('en-UK');
    }
  } else {
    return number.toLocaleString();
  }
};

formatters = {
  _formatNulls: function(value) {
    if (!utils.isNumeric(value)) {
      return '--';
    } else {
      return value;
    }
  },
  _toFixedNumber: function(value, scale) {
    if (scale == null) {
      scale = 2;
    }
    return value = utils.isNumeric(value) ? utils.parseFixedFloat(value, scale) : value;
  },
  _getDesignStudy: function(ds) {
    var designStudy, _ref;
    if (!ds) {
      return '';
    }
    designStudy = (_ref = ds.label) === 'randomised_trials' || _ref === 'single_arm_trial' ? ds.label : ds.value;
    return designStudy = designStudy != null ? designStudy.replace('ObsStudies.', '') : void 0;
  },
  outcome: {
    comments: function(text) {
      return _.string.escapeHTML(text);
    },
    _formatCerIfNaN: function(cer) {
      if (isNaN(cer)) {
        return 0;
      } else {
        return cer;
      }
    },
    qualityModifier: function(val) {
      if (val.label) {
        return $.t("es:outcome." + val.label);
      } else {
        return '';
      }
    },
    publicationBias: function(val) {
      if (!val) {
        return;
      }
      if ((val != null ? val.name : void 0) === 'Serious') {
        return $.t('es:outcome.publication_bias_strongly_suspected');
      } else {
        return $.t("es:outcome." + val.label);
      }
    },
    designStudies: function(_arg) {
      var count, designStudies, noOfStudies, text;
      designStudies = _arg.designStudies, noOfStudies = _arg.noOfStudies;
      count = !noOfStudies ? 0 : noOfStudies;
      text = (designStudies != null ? designStudies.label : void 0) ? $.t("es:outcome." + designStudies.label, {
        count: count
      }) : '';
      if (!mediator.services.switches.isOn('idsaFeatures')) {
        return text;
      }
      if (_.isEmpty(designStudies != null ? designStudies.value : void 0)) {
        return text;
      }
      return "" + text + "<br>(" + ($.t("es:outcome." + designStudies.value)) + ")";
    },
    importanceLabel: function(attributes) {
      return attributes['importanceLabel'];
    },
    _followUpOrTimingWithLabel: function(attributes, viewType) {
      var followUp, _ref;
      if (!attributes.followUpLength || attributes.followUpLength === '0') {
        return;
      }
      followUp = '';
      if (((_ref = attributes.designStudies) != null ? _ref.value : void 0) === 'case_control_studies') {
        followUp = $.t("es:outcome.timing_of_exposure") + ": ";
      } else {
        followUp = $.t("es:outcome.follow_up") + ": ";
      }
      followUp = viewType === "sof_v4" || viewType === "printoutsofv4" ? followUp : followUp.toLowerCase();
      return followUp += this._followUpOrTiming(attributes);
    },
    _followUpOrTiming: function(attributes) {
      var followUp;
      if (!attributes.followUpLength) {
        return;
      }
      followUp = '';
      if (attributes.followUpType) {
        followUp += $.t("es:outcome." + attributes.followUpType);
      }
      followUp += " " + (_.string.escapeHTML(attributes.followUpLength));
      if (attributes.followUpTimeUnit === 'others') {
        if (attributes.othersFollowUpTimeUnit) {
          followUp += " " + attributes.othersFollowUpTimeUnit;
        }
      } else if (attributes.followUpTimeUnit) {
        followUp += " " + ($.t("es:outcome." + (_.string.underscored(attributes.followUpTimeUnit))));
      }
      if (attributes.followUpType !== 'range') {
        return followUp;
      }
      followUp += " " + ($.t("es:outcome.to"));
      if (attributes.followUpLengthTo) {
        followUp += " " + (_.string.escapeHTML(attributes.followUpLengthTo));
      }
      if (attributes.followUpToTimeUnit === 'others') {
        if (attributes.othersFollowUpToTimeUnit) {
          followUp += " " + attributes.othersFollowUpToTimeUnit;
        }
      } else if (attributes.followUpToTimeUnit) {
        followUp += " " + ($.t("es:outcome." + (_.string.underscored(attributes.followUpToTimeUnit))));
      }
      return followUp;
    },
    _scaleRange: function(attributes, viewType) {
      var scale;
      if (!(attributes.type === 'cont' && attributes.scaleType === 'ordinal')) {
        return;
      }
      scale = '';
      if (attributes.scaleFrom && attributes.scaleTo) {
        if (viewType === 'one_row') {
          scale += "" + ($.t('es:outcome.range_of_scores').toLowerCase());
        } else {
          scale += "" + ($.t('es:outcome.scale'));
        }
        scale += " " + ($.t('es:outcome.from')) + ": " + attributes.scaleFrom + " " + ($.t('es:outcome.to')) + " " + attributes.scaleTo;
      }
      return scale;
    },
    _assessedWith: function(attributes, viewType) {
      if (attributes.measuredWith) {
        if (viewType === "sof_v4" || viewType === "printoutsofv4") {
          return "" + (_.string.escapeHTML(attributes.measuredWith));
        } else {
          return "" + ($.t('es:outcome.assessed_with')) + ": " + (_.string.escapeHTML(attributes.measuredWith));
        }
      } else {
        return '';
      }
    },
    label: function(attributes, viewType) {
      var assessedWith, defaultRows, followUp, i18nKey, inParenthesis, label, noOfParticipantsStudies, rows, scale, _ref;
      label = "" + (_.string.escapeHTML(attributes.name));
      if ((_ref = attributes._viewTypeName != null) === 'PrintoutSOF' || _ref === 'PrintoutSOFACCP') {
        label = "<b>" + label + "</b>";
      }
      if (attributes.metaType === 'NOT_MEASURED') {
        label += " - " + ($.t('es:outcome.not_measured'));
      } else if (attributes.metaType === 'NOT_REPORTED') {
        label += " - " + ($.t('es:outcome.not_reported'));
      } else {
        assessedWith = this._assessedWith(attributes, viewType);
        scale = this._scaleRange(attributes);
        followUp = this._followUpOrTimingWithLabel(attributes, viewType);
        defaultRows = [assessedWith, scale, followUp];
        if (viewType === 'one_row') {
          inParenthesis = _([followUp, assessedWith, scale]).filter(function(v) {
            return v && v.length;
          }).join('; ');
          if (inParenthesis) {
            label += " (" + inParenthesis + ")";
          }
        } else if (viewType === 'sof') {
          rows = _(defaultRows).filter(function(v) {
            return v && v.length;
          }).join('<br>');
          if (attributes.shortName) {
            label += " <span class='short-name'>(" + (_.string.escapeHTML(attributes.shortName)) + ")</span>";
          }
          if (rows.length) {
            label += "<br>" + rows;
          }
        } else if (viewType === "sof_v3" || viewType === "printoutsofv3") {
          i18nKey = mediator.services.switches.isServerSwitchOn('acpFeatures') ? 'no_of_participants_follow_up' : 'no_of_participants';
          noOfParticipantsStudies = "" + ($.t("es:outcome." + i18nKey)) + ": " + (this.noOfParticipantsStudies(attributes));
          defaultRows.push(noOfParticipantsStudies);
          rows = _(defaultRows).filter(function(v) {
            return v && v.length;
          }).join('<br>');
          if (attributes.shortName) {
            label += " <span class='short-name'>(" + (_.string.escapeHTML(attributes.shortName)) + ")</span>";
          }
          if (rows.length) {
            label += "<br>" + rows;
          }
        } else if (viewType === "sof_v4" || viewType === "printoutsofv4") {
          rows = _([scale, followUp]).filter(function(v) {
            return v && v.length;
          }).join('<br>');
          if (assessedWith.length) {
            label += ", " + assessedWith;
          }
          if (rows.length) {
            label += "<br>" + rows;
          }
        } else {
          rows = _(defaultRows).filter(function(v) {
            return v && v.length;
          }).join('<br>');
          if (rows.length) {
            label += "<br>" + rows;
          }
        }
      }
      return "<span class='label outcome-name'>" + label + "</span>";
    },
    testResult: function(attributes, options) {
      var name, _ref;
      if ((_ref = attributes.name) === 'TP' || _ref === 'FP' || _ref === 'TN' || _ref === 'FN') {
        name = "<span class='bold'>";
        name += $.t("es:outcome.diagnostic." + attributes.name);
        name += "</span>";
        name += "<BR/>";
        return name += $.t("es:outcome.diagnostic." + (attributes.name.toLowerCase()) + "_label", options);
      } else {
        return $.t("es:outcome.diagnostic." + (attributes.name.toLowerCase()));
      }
    },
    diagOutcomeLabel: function(attributes) {
      var name, _ref;
      name = (_ref = attributes.name) === 'TP' || _ref === 'FP' || _ref === 'TN' || _ref === 'FN' ? attributes.name : attributes.name.toLowerCase();
      return $.t("es:outcome.diagnostic." + name);
    },
    sofLabel: function(attributes) {
      return this.label(attributes, 'sof');
    },
    sofV3Label: function(attributes) {
      return this.label(attributes, 'sof_v3');
    },
    sofV4Label: function(attributes) {
      return this.label(attributes, 'sof_v4');
    },
    oneRowLabel: function(attributes) {
      return this.label(attributes, 'one_row');
    },
    sofRm5Label: function(attributes) {
      var sofLabel;
      sofLabel = this.sofLabel(attributes);
      return sofLabel.replace(/(<\/?\w+\b)(?:[^<>]*)(>)/g, function(m0, m1, m2) {
        if (m1.indexOf('<br') >= 0) {
          return m1.toUpperCase() + '/' + m2;
        } else {
          return '';
        }
      });
    },
    diagnosticLabel: function(attributes) {
      var diagnosticOutcome, info, isDxSofPrintout, label, name, _ref, _ref1;
      diagnosticOutcome = DO.get(attributes.name);
      isDxSofPrintout = (_ref = attributes._viewTypeName) === 'PrintoutLayerOneSof' || _ref === 'PrintoutLayerTwoSof';
      name = (_ref1 = diagnosticOutcome != null ? diagnosticOutcome.name : void 0) != null ? _ref1 : '';
      label = (diagnosticOutcome != null ? diagnosticOutcome.label : void 0) ? '<b>' + $.t("es:outcome.diagnostic." + diagnosticOutcome.label) + '</b>' : '';
      switch (name.toLowerCase()) {
        case 'tp':
        case 'fn':
        case 'tn':
        case 'fp':
          if (isDxSofPrintout) {
            return label;
          } else {
            info = $.t("es:outcome.diagnostic." + (attributes.name.toLowerCase()) + "_label", {
              condition: attributes.targetCondition
            });
            return label + ("<br>(" + info + ")");
          }
          break;
        case 'inconclusive':
          if (isDxSofPrintout) {
            return label + '*';
          } else {
            return label;
          }
          break;
        case 'complications':
          if (isDxSofPrintout) {
            return label + '**';
          } else {
            return label;
          }
          break;
        default:
          return label;
      }
    },
    diagnosticEffect: function(attributes, name, prevalenceNo, forComparator) {
      var absDenominator, attrName, diagEffectFn, effect, effectFrom, effectTo, prevalence, rangeFrom, rangeTo, _ref, _ref1;
      if (forComparator == null) {
        forComparator = false;
      }
      if (name !== 'TP' && name !== 'FN' && name !== 'TN' && name !== 'FP') {
        return '';
      }
      diagEffectFn = statisticalUtils["diagnosticEffect" + name].bind(statisticalUtils);
      attrName = name === 'TP' || name === 'FN' ? 'pooledSensitivity' : 'pooledSpecificity';
      if (forComparator) {
        attrName += 'Comparison';
      }
      prevalence = attributes["prevalence" + prevalenceNo];
      absDenominator = attributes.absDenominator;
      if (attributes.sourceOfDxData === 'rangeFromStudies') {
        rangeFrom = diagEffectFn(attributes["" + attrName + "RangeFrom"], prevalence, absDenominator);
        rangeTo = diagEffectFn(attributes["" + attrName + "RangeTo"], prevalence, absDenominator);
        if (rangeFrom > rangeTo) {
          _ref = [rangeTo, rangeFrom], rangeFrom = _ref[0], rangeTo = _ref[1];
        }
        return "" + rangeFrom + " " + ($.t('es:outcome.to')) + " " + rangeTo;
      } else {
        effect = diagEffectFn(attributes["" + attrName], prevalence, absDenominator);
        effectFrom = diagEffectFn(attributes["" + attrName + "From"], prevalence, absDenominator);
        effectTo = diagEffectFn(attributes["" + attrName + "To"], prevalence, absDenominator);
        if (effectFrom > effectTo) {
          _ref1 = [effectTo, effectFrom], effectFrom = _ref1[0], effectTo = _ref1[1];
        }
        return ("<span class=\"effect\">" + effect + "</span>") + (" (" + effectFrom + " " + ($.t('es:outcome.to')) + " " + effectTo + ")");
      }
    },
    _fewerMoreText: function(value) {
      if (value < 0) {
        return $.t('es:outcome.more');
      } else {
        return $.t('es:outcome.fewer');
      }
    },
    _diagDiff: function(attributes, diagEffectFn, prevalence, attrNames) {
      var absDenominator, comparatorEffect, indexEffect;
      absDenominator = attributes.absDenominator;
      indexEffect = diagEffectFn(attributes[attrNames[1]], prevalence, absDenominator);
      comparatorEffect = diagEffectFn(attributes[attrNames[0]], prevalence, absDenominator);
      return indexEffect - comparatorEffect;
    },
    diagnosticAbsoluteDifference: function(attributes, name, prevalenceNo) {
      var diagEffectFn, diffAttrNames, diffFromAttrNames, diffToAttrNames, difference, differenceFrom, differenceTo, params, prevalence, sensitivityOrSpecificity;
      prevalence = attributes["prevalence" + prevalenceNo];
      if (name !== 'TP' && name !== 'FN' && name !== 'TN' && name !== 'FP') {
        return '';
      }
      sensitivityOrSpecificity = (function() {
        switch (name) {
          case 'TP':
          case 'FN':
            return 'Sensitivity';
          case 'TN':
          case 'FP':
            return 'Specificity';
        }
      })();
      diagEffectFn = statisticalUtils["diagnosticEffect" + name].bind(statisticalUtils);
      if (attributes.sourceOfDxData === 'rangeFromStudies') {
        diffFromAttrNames = ["pooled" + sensitivityOrSpecificity + "RangeFrom", "pooled" + sensitivityOrSpecificity + "ComparisonRangeFrom"];
        diffToAttrNames = ["pooled" + sensitivityOrSpecificity + "RangeTo", "pooled" + sensitivityOrSpecificity + "ComparisonRangeTo"];
        differenceFrom = this._diagDiff(attributes, diagEffectFn, prevalence, diffFromAttrNames);
        differenceTo = this._diagDiff(attributes, diagEffectFn, prevalence, diffToAttrNames);
        params = {
          outcome: $.t("es:outcome.diagnostic." + name + "_short"),
          testName: attributes.indexTest,
          differenceFromValue: Math.abs(differenceFrom),
          differenceToValue: Math.abs(differenceTo),
          fewerMoreFrom: this._fewerMoreText(differenceFrom),
          fewerMoreTo: this._fewerMoreText(differenceTo)
        };
        return $.t('es:outcome.diagnostic.absolute_difference_range_template', params);
      } else {
        diffAttrNames = ["pooled" + sensitivityOrSpecificity, "pooled" + sensitivityOrSpecificity + "Comparison"];
        difference = this._diagDiff(attributes, diagEffectFn, prevalence, diffAttrNames);
        params = {
          outcome: $.t("es:outcome.diagnostic." + name + "_short"),
          testName: attributes.indexTest,
          differenceValue: Math.abs(difference),
          fewerMore: this._fewerMoreText(difference)
        };
        return $.t('es:outcome.diagnostic.absolute_difference_template', params);
      }
    },
    quality: function(attributes) {
      var circleWithPlus, circles, emptyCircle, isAcp, isCadth, isPrintout, qm, qms, qualityPlusCircles, qualityText, qualityVal, sd, translKey;
      isAcp = mediator.services.switches.isServerSwitchOn('acpFeatures');
      isCadth = mediator.services.switches.isServerSwitchOn('cadthFeatures');
      qualityVal = '';
      if (attributes.quality) {
        if (attributes.rm5export) {
          circleWithPlus = '&#8853;';
          emptyCircle = '&#8861;';
        } else {
          circleWithPlus = '<span class="quality-sign">&#x2a01;</span>';
          emptyCircle = '<span class="quality-sign">&#x25ef;</span>';
        }
        qualityPlusCircles = isAcp ? attributes.quality - 1 : attributes.quality;
        circles = _.string.repeat(circleWithPlus, qualityPlusCircles) + _.string.repeat(emptyCircle, 4 - attributes.quality);
        translKey = _.string.underscored(Qualities[attributes.quality].toLowerCase());
        if (attributes.quality === 1 && isAcp) {
          translKey += '_acp';
        }
        qualityText = '<span class="quality-text">' + _.string.capitalize($.t("es:outcome.qualities." + translKey)) + '</span>';
        if (circles && !isCadth) {
          qualityVal = "" + circles + "<br>" + qualityText;
        } else {
          qualityVal = qualityText;
        }
      } else {
        qms = (function() {
          var _i, _len, _ref, _results;
          _ref = Outcome.QUALITY_MODIFIERS;
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            qm = _ref[_i];
            _results.push(attributes[qm]);
          }
          return _results;
        })();
        isPrintout = function() {
          var _ref;
          return ((_ref = attributes._viewTypeName) != null ? _ref.toLowerCase().indexOf('printout') : void 0) !== -1;
        };
        if (Outcome.areQualityModifiersSet(qms) && !isPrintout()) {
          sd = ($.t('es:outcome.study_design')).replace(' ', '&nbsp;');
          sd = "<span class='salmon-bg'>" + sd + "</span>";
          qualityVal = $.t('es:outcome.messages.certainty_parameter_not_defined', {
            param: sd
          });
        }
      }
      if (!qualityVal) {
        qualityVal = '-';
      }
      return qualityVal;
    },
    controlRatio: function(attributes) {
      var ratio;
      ratio = (attributes.controlCount / attributes.controlTotal) * 100;
      if (isNaN(ratio)) {
        return '-';
      } else {
        return ratio.toFixed(1);
      }
    },
    _numberOrDash: function(value) {
      if (_(value).isNumber()) {
        return value;
      } else {
        return '-';
      }
    },
    _interventionsAndComparisions: function(attributes, interventionOrControl) {
      var icCount, icTotal, interventionAndComparatorDecimalPlaces, interventionsOrComparisions, percent, _ref;
      icCount = attributes["" + interventionOrControl + "Count"];
      icTotal = attributes["" + interventionOrControl + "Total"];
      interventionAndComparatorDecimalPlaces = (_ref = attributes.interventionAndComparatorDecimalPlaces) != null ? _ref : 1;
      interventionsOrComparisions = "";
      switch (attributes.type) {
        case 'dich':
        case 'narrative':
          interventionsOrComparisions += _(icCount).isNumber() || _(icTotal).isNumber() ? "" + (this._numberOrDash(icCount)) + "/" + (this._numberOrDash(icTotal)) : '';
          if (icTotal > 0 && _(icCount).isNumber()) {
            percent = ((icCount / icTotal) * 100).toFixed(interventionAndComparatorDecimalPlaces);
            if (attributes.effectMeasure !== 'rateRatio') {
              interventionsOrComparisions += " (" + percent + "%) ";
            }
          }
          break;
        case 'cont':
          interventionsOrComparisions += "" + icTotal;
          break;
        case 'time_to_event':
          interventionsOrComparisions += icTotal ? ("" + icTotal + " " + ($.t('es:outcome.participants'))).toLowerCase() : "";
      }
      return interventionsOrComparisions;
    },
    intervention: function(attributes) {
      return this._interventionsAndComparisions(attributes, 'intervention');
    },
    calculatedControlLabel: function(attributes) {
      return $.t('es:outcome.printout.study_population');
    },
    lowControlLabel: function(attributes) {
      return attributes.lowControlLabel;
    },
    moderateControlLabel: function(attributes) {
      return attributes.moderateControlLabel;
    },
    highControlLabel: function(attributes) {
      return attributes.highControlLabel;
    },
    control: function(attributes) {
      var _ref, _ref1;
      if ((_ref = (_ref1 = attributes._viewTypeName) != null ? _ref1.toLowerCase() : void 0) === 'sof' || _ref === 'accp' || _ref === "sof_v3" || _ref === 'sof_v4' || _ref === 'printoutsofv3' || _ref === 'printoutsof' || _ref === 'sof_accp' || _ref === 'printoutsofv4' || _ref === 'printoutsofaccp' || _ref === 'sof_short') {
        return this.sofControl(attributes);
      } else {
        return this._interventionsAndComparisions(attributes, 'control');
      }
    },
    formatDichSofControl: function(risk, absDenominator, outputDenominator) {
      var value;
      if (outputDenominator == null) {
        outputDenominator = true;
      }
      if (isNaN(risk)) {
        risk = 0;
      }
      value = $.isNumeric(absDenominator) ? numberToLocaleString((risk * absDenominator).toFixed(0)) : numberToLocaleString(absDenominator);
      if (outputDenominator) {
        return value += " " + ($.t('es:outcome.per')) + " " + (numberToLocaleString(absDenominator));
      }
    },
    dichSofControl: function(attributes, outputDenominator) {
      var risk;
      if (outputDenominator == null) {
        outputDenominator = true;
      }
      risk = attributes.controlCount / attributes.controlTotal;
      return this.formatDichSofControl(risk, attributes.absDenominator, outputDenominator);
    },
    dichSofControlPercent: function(attributes, outputDenominator) {
      var risk;
      if (outputDenominator == null) {
        outputDenominator = false;
      }
      risk = attributes.controlCount / attributes.controlTotal;
      if (isNaN(risk)) {
        risk = 0;
      }
      return this.percentValue(this._convertToPercentValue(risk));
    },
    contSofControl: function(attributes) {
      var contSofControl, score, _ref, _ref1, _ref2, _ref3;
      if ((_ref = (_ref1 = attributes._viewTypeName) != null ? _ref1.toLowerCase() : void 0) === "sof_v4" || _ref === "printoutsofv4") {
        return "<span class='cell-value pt8'>" + (attributes.changeScoreInControlsValue ? attributes.changeScoreInControlsValue + " " + attributes.units : 0) + "</span>";
      }
      score = attributes.changeScoreInControls === 'median' ? $.t("es:outcome.the_median") : $.t("es:outcome.the_mean");
      contSofControl = "" + score + " " + (utils.uncapitalizeExceptAllCaps(attributes.name)) + " ";
      if ((_ref2 = (_ref3 = attributes._viewTypeName) != null ? _ref3.toLowerCase() : void 0) === "sof_v3" || _ref2 === "printoutsofv3") {
        contSofControl += ("" + ($.t('es:outcome.without'))).toLowerCase();
        contSofControl += " " + (utils.uncapitalizeExceptAllCaps(attributes.intervention)) + " ";
      }
      if (attributes.changeScoreInControls === 'range') {
        contSofControl += "" + ($.t('es:outcome.ranged')) + " " + ($.t('es:outcome.from')) + " ";
      } else {
        contSofControl += "" + ($.t('es:outcome.was')) + " ";
      }
      contSofControl += "<b>";
      if (attributes.changeScoreInControlsValue) {
        contSofControl += "" + attributes.changeScoreInControlsValue;
      } else {
        contSofControl += 0;
      }
      contSofControl += "</b>";
      if (attributes.units) {
        contSofControl += " " + attributes.units;
      }
      return "<span class='cell-value pt8'>" + contSofControl + "</span>";
    },
    lowControlRisk: function(attributes) {
      var risk, value, _ref, _ref1;
      value = '';
      if ((_ref = (_ref1 = attributes._viewTypeName) != null ? _ref1.toLowerCase() : void 0) === 'sof' || _ref === 'accp' || _ref === 'printoutsof' || _ref === 'sof_accp' || _ref === 'printoutsofaccp' || _ref === 'printoutgradeaccp' || _ref === 'sof_short' || _ref === 'sof_v4' || _ref === 'printoutsofv4') {
        risk = attributes.lowControlRisk / 100;
        return value += this.formatDichSofControl(risk, attributes.absDenominator);
      } else {
        return this.percentValue(attributes.lowControlRisk, attributes.interventionAndComparatorDecimalPlaces);
      }
    },
    moderateControlRisk: function(attributes) {
      var risk, value, _ref, _ref1;
      value = '';
      if ((_ref = (_ref1 = attributes._viewTypeName) != null ? _ref1.toLowerCase() : void 0) === 'sof' || _ref === 'accp' || _ref === 'printoutsof' || _ref === 'sof_accp' || _ref === 'printoutsofaccp' || _ref === 'printoutgradeaccp' || _ref === 'sof_short' || _ref === 'sof_v4' || _ref === 'printoutsofv4') {
        risk = attributes.moderateControlRisk / 100;
        return value += this.formatDichSofControl(risk, attributes.absDenominator);
      } else {
        return this.percentValue(attributes.moderateControlRisk, attributes.interventionAndComparatorDecimalPlaces);
      }
    },
    highControlRisk: function(attributes) {
      var risk, value, _ref, _ref1;
      value = '';
      if ((_ref = (_ref1 = attributes._viewTypeName) != null ? _ref1.toLowerCase() : void 0) === 'sof' || _ref === 'accp' || _ref === 'printoutsof' || _ref === 'sof_accp' || _ref === 'printoutsofaccp' || _ref === 'printoutgradeaccp' || _ref === 'sof_short' || _ref === 'sof_v4' || _ref === 'printoutsofv4') {
        risk = attributes.highControlRisk / 100;
        return value += this.formatDichSofControl(risk, attributes.absDenominator);
      } else {
        return this.percentValue(attributes.highControlRisk, attributes.interventionAndComparatorDecimalPlaces);
      }
    },
    sofControl: function(attributes) {
      var _ref, _ref1, _ref2;
      if (!attributes.showFinalScoreInControls) {
        return "";
      }
      if ((_ref = attributes.type) === 'dich' || _ref === 'time_to_event') {
        if ((_ref1 = (_ref2 = attributes._viewTypeName) != null ? _ref2.toLowerCase() : void 0) === "sof_v3" || _ref1 === "printoutsofv3") {
          return this.dichSofControlPercent(attributes);
        } else {
          return this.dichSofControl(attributes);
        }
      } else if (attributes.type === 'cont') {
        return this.contSofControl(attributes);
      }
    },
    recommendationControl: function(attributes, denominator) {
      var _ref;
      if ((_ref = attributes.metaType) === 'NOT_MEASURED' || _ref === 'NOT_REPORTED') {
        return '-';
      } else if (attributes.type !== 'cont' && denominator) {
        return this.dichSofControl(_.extend(_(attributes).clone(), {
          absDenominator: denominator
        }), false);
      } else {
        return this.sofControl(attributes);
      }
    },
    recommendationIntervention: function(attributes, denominator) {
      var cer, _ref;
      if ((_ref = attributes.metaType) === 'NOT_MEASURED' || _ref === 'NOT_REPORTED') {
        return '-';
      } else if (attributes.type !== 'cont' && denominator) {
        cer = this._formatCerIfNaN(attributes.controlCount / attributes.controlTotal);
        return this._dichCorrespondingRisk(cer, attributes, '', false);
      } else {
        return this.correspondingRisk(attributes);
      }
    },
    otherConsiderations: function(attributes) {
      var value, values, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
      values = [];
      if (((_ref = attributes.publicationBias) != null ? _ref.name : void 0) === 'Serious') {
        values.push($.t('es:outcome.publication_bias_strongly_suspected'));
      }
      if (((_ref1 = attributes.largeEffect) != null ? _ref1.score : void 0) > 0) {
        values.push($.t("es:outcome." + attributes.largeEffect.label));
      }
      if ((_ref2 = (_ref3 = (_ref4 = attributes.plausibleConfounding) != null ? _ref4.name : void 0) != null ? _ref3 : 'None') !== 'None' && _ref2 !== 'No') {
        values.push($.t("es:outcome." + attributes.plausibleConfounding.label + "_long"));
      }
      if ((_ref5 = (_ref6 = attributes.doseResponseGradient) != null ? _ref6.name : void 0) === 'Large' || _ref5 === 'Yes') {
        values.push($.t('es:outcome.dose_response_gradient'));
      }
      value = values.join('<br>');
      if (_.chain(attributes).pick('publicationBias', 'largeEffect', 'plausibleConfounding', 'doseResponseGradient').values().compact().value().length !== 4) {
        return '';
      }
      if (attributes.publicationBias && !value) {
        value = $.t('es:outcome.none');
      }
      return value.toLowerCase();
    },
    _isRelativeEffectEstimable: function(attributes) {
      return Boolean(attributes.effectMeasure && (attributes.effectSize || attributes.confidenceIntervalFrom || attributes.confidenceIntervalTo));
    },
    _getFixedScaleForRelativeEffect: function(es, cif, cit) {
      var scales;
      scales = _(["" + es, "" + cif, "" + cit]).map(function(v) {
        var parts;
        parts = v.split('.');
        if (parts[1]) {
          return parts[1].length;
        } else {
          return 0;
        }
      });
      return Math.max.apply(Math, scales);
    },
    relativeEffect: function(attributes, stripHTML) {
      var cif, cit, effectM, es, eventName, formatted, isRangeOfEffects, relEffect, scale, translatedEM, vaccineEstimateCif, vaccineEstimateCit, _ref, _ref1, _ref2, _ref3, _ref4;
      if (stripHTML == null) {
        stripHTML = false;
      }
      isRangeOfEffects = attributes.metaType === 'RANGE_OF_EFFECTS';
      es = parseFloat(attributes.effectSize);
      cif = parseFloat(attributes.confidenceIntervalFrom);
      cit = parseFloat(attributes.confidenceIntervalTo);
      scale = Math.min(this._getFixedScaleForRelativeEffect(es, cif, cit), 2);
      relEffect = '-';
      if ((_ref = attributes.type) === 'dich' || _ref === 'time_to_event') {
        if (attributes.metaType === 'NOT_POOLED') {
          relEffect = getCapitalizedValueForCochrane('es:outcome.', 'not_pooled');
        } else if (!this._isRelativeEffectEstimable(attributes)) {
          relEffect = getCapitalizedValueForCochrane('es:outcome.', 'not_estimable');
        } else {
          relEffect = "<span class='block'>";
          effectM = (_ref1 = attributes.effectMeasure) === 'VEOR' || _ref1 === 'VEHR' ? attributes.effectMeasure.replace('VE', '') : attributes.effectMeasure;
          if ((_ref2 = attributes.effectMeasure) === 'VEOR' || _ref2 === 'VEHR') {
            _ref3 = [(1 - cif) * 100, (1 - cit) * 100].sort(function(a, b) {
              return a - b;
            }), vaccineEstimateCif = _ref3[0], vaccineEstimateCit = _ref3[1];
            relEffect += "<b>";
            relEffect += $.t('es:outcome.vaccine_estimate_short').toUpperCase();
            relEffect += " ";
            relEffect += formatters._toFixedNumber(formatters._formatNulls(attributes.vaccineEstimate), 0);
            relEffect += "%";
            relEffect += '</b><br>';
            relEffect += '(';
            relEffect += formatters._toFixedNumber(formatters._formatNulls(vaccineEstimateCif), scale);
            relEffect += " " + ($.t("es:outcome.to")) + " ";
            relEffect += formatters._toFixedNumber(formatters._formatNulls(vaccineEstimateCit), scale);
            relEffect += ')';
            relEffect += '<br><br>';
          }
          relEffect += "<b>";
          translatedEM = $.t("es:outcome.measure." + (_.string.underscored(effectM)));
          relEffect += "" + (effectM === 'other' ? attributes.otherMeasure : translatedEM) + " ";
          if ((_ref4 = attributes._viewTypeName) === 'SOF_v4' || _ref4 === 'PrintoutSOFv4') {
            relEffect += "= ";
          }
          if (isRangeOfEffects) {
            relEffect += "" + ($.t('es:outcome.ranged')) + " " + ($.t('es:outcome.from')) + " ";
          } else {
            relEffect += formatters._toFixedNumber(formatters._formatNulls(es), scale);
          }
          relEffect += '</b></span><br>';
          if (!isRangeOfEffects) {
            relEffect += '(';
          }
          relEffect += formatters._toFixedNumber(formatters._formatNulls(cif), scale);
          relEffect += " " + ($.t("es:outcome.to")) + " ";
          relEffect += formatters._toFixedNumber(formatters._formatNulls(cit), scale);
          if (!isRangeOfEffects) {
            relEffect += ')';
          }
          if (attributes.type === 'time_to_event') {
            eventName = attributes.eventType === 'non_event' ? attributes.nonEvent : attributes.name;
            relEffect += "<br/>[" + eventName + "]";
          }
        }
      }
      formatted = "<span class='cell'>" + relEffect + "</span>";
      if (stripHTML) {
        formatted = formatted.replace(/<[^>]*>/g, ' ');
        formatted = formatted.replace(/\s+/g, ' ');
      }
      return formatted.trim();
    },
    percentValue: function(value, decimalPlaces) {
      if (decimalPlaces == null) {
        decimalPlaces = 1;
      }
      value = formatters._toFixedNumber(value, decimalPlaces);
      return "" + value + "%";
    },
    _convertToPercentValue: function(value) {
      return formatters._toFixedNumber((value *= 100), 1);
    },
    _attrWithOtherValue: function(attributes, attrName, otherAttrName) {
      var _ref;
      if ((_ref = attributes[attrName]) === 'other' || _ref === 'others') {
        return attributes[otherAttrName];
      } else {
        return attributes[attrName];
      }
    },
    _formatFewerMore: function(value, percent, scale) {
      var fewerMore;
      if (percent == null) {
        percent = false;
      }
      if (scale == null) {
        scale = 0;
      }
      if ($.isNumeric(value)) {
        fewerMore = value < 0 ? $.t('es:outcome.more') : $.t('es:outcome.fewer');
        value = formatters._toFixedNumber(Math.abs(value), scale);
        value = percent ? this.percentValue(value) : numberToLocaleString(Number(value));
        return "" + value + " " + fewerMore;
      } else {
        return formatters._formatNulls(value);
      }
    },
    _orderCIFromCITo: function(ciFrom, ciTo) {
      return R.sort(R.comparator(R.gte), [ciFrom, ciTo]);
    },
    _perValue: function(attributes) {
      if (attributes.effectMeasure === 'rateRatio') {
        return "" + ($.t("es:outcome.per")) + " " + (this._attrWithOtherValue(attributes, 'perPatients', 'perPatientsOther')) + " " + ($.t("es:outcome.patient_s")) + " " + ($.t("es:outcome.per")) + " " + (this._attrWithOtherValue(attributes, 'perTimeFrame', 'perTimeFrameOther')) + " ";
      } else {
        return "" + ($.t("es:outcome.per")) + " " + (numberToLocaleString(attributes.absDenominator));
      }
    },
    _dichAbsoluteEffect: function(attributes, defaultCerName) {
      var absEffectFrom, absEffectTo, value, _ref;
      if (defaultCerName == null) {
        defaultCerName = '';
      }
      if (isNaN(attributes["absEffectSize" + defaultCerName])) {
        return '--';
      } else if (this._isRelativeEffectEstimable(attributes) || (!attributes.absEffectAutoCalc)) {
        absEffectFrom = attributes["absEffectFrom" + defaultCerName];
        absEffectTo = attributes["absEffectTo" + defaultCerName];
        _ref = this._orderCIFromCITo(absEffectFrom, absEffectTo), absEffectFrom = _ref[0], absEffectTo = _ref[1];
        value = '<b>';
        value += this._formatFewerMore(attributes["absEffectSize" + defaultCerName]);
        value += ' ';
        value += this._perValue(attributes);
        value += '</b><br>';
        value += "(" + ($.t("es:outcome.from")) + " ";
        value += this._formatFewerMore(absEffectFrom);
        value += " " + ($.t("es:outcome.to")) + " ";
        value += this._formatFewerMore(absEffectTo);
        return value += ')';
      } else {
        return '';
      }
    },
    _contAbsoluteEffect: function(attributes) {
      var cif, cit, countable, effectSize, unitsType, value, _ref;
      effectSize = attributes.effectSize;
      cif = attributes.confidenceIntervalFrom;
      cit = attributes.confidenceIntervalTo;
      unitsType = attributes.unitsType;
      countable = unitsType === "countable" || _.isEmpty(unitsType);
      value = "<span class='cell-value pt8'>";
      if ((_ref = attributes._viewTypeName) === 'SOF_v4' || _ref === 'PrintoutSOFv4') {
        value += "<b>" + effectSize + "</b>";
        value += "</b><br>(" + cif + " ";
        value += ' ';
        value += $.t("es:outcome.to");
        value += " " + cit + ")";
      } else {
        value += "" + (this._attrWithOtherValue(attributes, 'effectMeasure', 'otherMeasure')) + " ";
        value += "<b>" + (Math.abs(effectSize)) + " ";
        if (attributes.units && attributes.units !== '') {
          value += "" + attributes.units + " ";
        }
        value += this._translateCountableUnitsType(attributes.effectSize, countable);
        value += "</b><br>(" + (Math.abs(cif)) + " ";
        value += this._translateCountableUnitsType(cif, countable);
        value += ' ';
        value += $.t("es:outcome.to");
        value += " " + (Math.abs(cit)) + " ";
        value += this._translateCountableUnitsType(cit, countable);
        value += ')';
      }
      value += '</span>';
      return value;
    },
    _translateCountableUnitsType: function(value, countable) {
      var translation;
      if (!value) {
        return '';
      }
      translation = countable ? value >= 0 ? 'higher' : 'lower' : value >= 0 ? 'more' : 'fewer';
      return $.t("es:outcome." + translation);
    },
    absoluteEffect: function(attributes, stripHTML) {
      var formatted, _ref;
      if (stripHTML == null) {
        stripHTML = false;
      }
      formatted = (_ref = attributes.type) === 'dich' || _ref === 'time_to_event' ? this._dichAbsoluteEffect(attributes) : this._contAbsoluteEffect(attributes);
      if (stripHTML) {
        formatted = formatted.replace(/<[^>]*>/g, ' ');
        formatted = formatted.replace(/\s+/g, ' ');
      }
      return formatted.trim();
    },
    absoluteEffectLow: function(attributes) {
      return this._dichAbsoluteEffect(attributes, 'Low');
    },
    absoluteEffectModerate: function(attributes) {
      return this._dichAbsoluteEffect(attributes, 'Moderate');
    },
    absoluteEffectHigh: function(attributes) {
      return this._dichAbsoluteEffect(attributes, 'High');
    },
    caseControl: function(attributes) {
      var caseControl, _ref;
      caseControl = "" + attributes.withOutcome + " " + ($.t('es:outcome.cases')) + " " + attributes.withoutOutcome + " " + ($.t('es:outcome.controls'));
      if (((_ref = attributes.designStudies) != null ? _ref.value : void 0) === 'case_control_and_other_combined') {
        caseControl += " " + attributes.interventionCount + "/" + attributes.interventionTotal + " " + ($.t('es:outcome.exposed')) + " " + attributes.controlCount + "/" + attributes.controlTotal + " " + ($.t('es:outcome.unexposed'));
      }
      return caseControl;
    },
    noOfParticipantsStudies: function(attributes) {
      var participants, studies;
      studies = this._formatDesignStudiesForACCPandSoF(attributes.noOfStudies, attributes.designStudies);
      participants = this._noOfParticipantsStudies(attributes);
      return _([participants, studies]).compact().join('<br>');
    },
    _noOfParticipantsStudies: function(attributes) {
      var designStudy;
      designStudy = formatters._getDesignStudy(attributes.designStudies);
      if (OutcomesHelper.isCaseControlType(designStudy)) {
        return this.caseControl(attributes);
      } else {
        return Number(attributes.interventionTotal) + Number(attributes.controlTotal);
      }
    },
    noOfStudies: function(attributes) {
      var _ref;
      if (mediator.services.switches.isOn('idsaFeatures') && attributes.useFreeFormNoOfStudies) {
        return attributes.freeFormNoOfStudies;
      } else if ((_ref = attributes.noOfStudies) != null ? _ref.toString().length : void 0) {
        return "" + attributes.noOfStudies;
      } else {
        return '';
      }
    },
    noOfStudiesPatients: function(attributes) {
      var value;
      value = "" + attributes.noOfStudies + " " + ($.t('es:outcome.studies'));
      return value += "<br>" + attributes.noOfPatients + " " + ($.t('es:outcome.patients'));
    },
    noOfParticipantsStudiesDiagnostic: function(attributes) {
      var noOfStudies, _ref;
      if ((_ref = attributes.noOfStudies) != null ? _ref.toString().length : void 0) {
        noOfStudies = "(" + attributes.noOfStudies + ")";
      }
      return _([attributes.noOfPatients, noOfStudies]).compact().join('<br>');
    },
    _multiplyByDenominator: function(cr, absDenominator) {
      if ($.isNumeric(absDenominator)) {
        return (cr * absDenominator).toFixed(0);
      } else {
        return '-';
      }
    },
    _getCorrespondingRiskValues: function(attributes, defaultCerName) {
      var absDenominator, absEffectAutoCalc, confidenceIntervalFrom, confidenceIntervalTo, controlCount, controlTotal, effectMeasure, effectSize, eventType, from, interventionConfidenceIntervalFrom, interventionConfidenceIntervalTo, interventionCount, interventionTotal, risk, riskValue, to, _ref, _ref1, _viewTypeName;
      if (defaultCerName == null) {
        defaultCerName = '';
      }
      absDenominator = attributes.absDenominator, absEffectAutoCalc = attributes.absEffectAutoCalc, confidenceIntervalFrom = attributes.confidenceIntervalFrom, confidenceIntervalTo = attributes.confidenceIntervalTo, controlCount = attributes.controlCount, controlTotal = attributes.controlTotal, effectMeasure = attributes.effectMeasure, effectSize = attributes.effectSize, eventType = attributes.eventType, interventionCount = attributes.interventionCount, interventionTotal = attributes.interventionTotal, _viewTypeName = attributes._viewTypeName, interventionConfidenceIntervalFrom = attributes.interventionConfidenceIntervalFrom, interventionConfidenceIntervalTo = attributes.interventionConfidenceIntervalTo;
      risk = this._formatCerIfNaN(defaultCerName === '' ? controlCount / controlTotal : attributes["" + (defaultCerName.toLowerCase()) + "ControlRisk"] / 100);
      _ref = (_viewTypeName === 'SOF_v4' || _viewTypeName === 'PrintoutSOFv4') && !absEffectAutoCalc ? [interventionCount && interventionTotal ? this._multiplyByDenominator(Number(interventionCount) / Number(interventionTotal), absDenominator) : void 0, interventionConfidenceIntervalFrom && interventionTotal ? this._multiplyByDenominator(Number(interventionConfidenceIntervalFrom) / Number(interventionTotal), absDenominator) : void 0, interventionConfidenceIntervalTo && interventionTotal ? this._multiplyByDenominator(Number(interventionConfidenceIntervalTo) / Number(interventionTotal), absDenominator) : void 0] : !absEffectAutoCalc ? [utils.isNumeric(attributes["absEffectSize" + defaultCerName]) ? (risk * absDenominator).toFixed(0) - attributes["absEffectSize" + defaultCerName] : void 0, utils.isNumeric(attributes["absEffectFrom" + defaultCerName]) ? (risk * absDenominator).toFixed(0) - attributes["absEffectFrom" + defaultCerName] : void 0, utils.isNumeric(attributes["absEffectTo" + defaultCerName]) ? (risk * absDenominator).toFixed(0) - attributes["absEffectTo" + defaultCerName] : void 0] : [risk ? Number(this._multiplyByDenominator(statisticalUtils.calculateCorrespondingRisk(risk, effectSize, effectMeasure, eventType), absDenominator)) : void 0, confidenceIntervalFrom ? Number(this._multiplyByDenominator(statisticalUtils.calculateCorrespondingRisk(risk, confidenceIntervalFrom, effectMeasure, eventType), absDenominator)) : void 0, confidenceIntervalTo ? Number(this._multiplyByDenominator(statisticalUtils.calculateCorrespondingRisk(risk, confidenceIntervalTo, effectMeasure, eventType), absDenominator)) : void 0], riskValue = _ref[0], from = _ref[1], to = _ref[2];
      _ref1 = [from, to].sort(function(a, b) {
        return a - b;
      }), from = _ref1[0], to = _ref1[1];
      return [riskValue, from, to];
    },
    _dichCorrespondingRisk: function(cer, attributes, defaultCerName, outputDenominator) {
      var absDenominator, cr, from, riskValue, to, _ref;
      if (outputDenominator == null) {
        outputDenominator = true;
      }
      absDenominator = attributes.absDenominator;
      _ref = this._getCorrespondingRiskValues(attributes, defaultCerName), riskValue = _ref[0], from = _ref[1], to = _ref[2];
      cr = ' <b>';
      cr += numberToLocaleString(riskValue);
      if (outputDenominator) {
        cr += " " + ($.t('es:outcome.per')) + " " + (numberToLocaleString(absDenominator));
      }
      cr += '</b><br>(';
      cr += numberToLocaleString(from);
      cr += " " + ($.t('es:outcome.to')) + " ";
      cr += numberToLocaleString(to);
      cr += ')';
      return "<span class='cell-value'>" + cr + "</span>";
    },
    _dichCorrespondingRiskPercent: function(cer, attributes, defaultCerName) {
      var absDenominator, absEffectAutoCalc, absEffectFrom, absEffectSize, absEffectTo, confidenceIntervalFrom, confidenceIntervalTo, cr, effectMeasure, effectSize, eventType, from, risk, to, value, _ref, _ref1;
      if (defaultCerName == null) {
        defaultCerName = '';
      }
      absDenominator = attributes.absDenominator, absEffectAutoCalc = attributes.absEffectAutoCalc, confidenceIntervalFrom = attributes.confidenceIntervalFrom, confidenceIntervalTo = attributes.confidenceIntervalTo, effectMeasure = attributes.effectMeasure, effectSize = attributes.effectSize, eventType = attributes.eventType;
      _ref = absEffectAutoCalc ? [statisticalUtils.calculateCorrespondingRisk(cer, effectSize, effectMeasure, eventType), statisticalUtils.calculateCorrespondingRisk(cer, confidenceIntervalFrom, effectMeasure, eventType), statisticalUtils.calculateCorrespondingRisk(cer, confidenceIntervalTo, effectMeasure, eventType)] : (risk = defaultCerName === '' ? attributes.controlCount / attributes.controlTotal : attributes["" + (defaultCerName.toLowerCase()) + "ControlRisk"] / 100, absDenominator = absDenominator, absEffectSize = attributes["absEffectSize" + defaultCerName], value = utils.isNumeric(absEffectSize) ? (risk * absDenominator).toFixed(0) - absEffectSize : void 0, absEffectFrom = utils.isNumeric(attributes["absEffectFrom" + defaultCerName]) ? attributes["absEffectFrom" + defaultCerName] : void 0, absEffectTo = utils.isNumeric(attributes["absEffectTo" + defaultCerName]) ? attributes["absEffectTo" + defaultCerName] : void 0, [value / absDenominator, ((risk * absDenominator) - absEffectFrom) / absDenominator, ((risk * absDenominator) - absEffectTo) / absDenominator]), value = _ref[0], from = _ref[1], to = _ref[2];
      _ref1 = [from, to].sort(function(a, b) {
        return a - b;
      }), from = _ref1[0], to = _ref1[1];
      cr = ' <b>';
      cr += utils.isNumeric(value) ? this.percentValue(this._convertToPercentValue(value)) : '--';
      cr += '</b><br>(';
      cr += utils.isNumeric(absEffectFrom) ? Number(this._convertToPercentValue(from)) : '--';
      cr += " " + ($.t('es:outcome.to')) + " ";
      cr += utils.isNumeric(absEffectTo) ? Number(this._convertToPercentValue(to)) : '--';
      cr += ')';
      return "<span class='cell-value'>" + cr + "</span>";
    },
    _translateEffectMeasure: function(effectMeasure, otherMeasure) {
      if (effectMeasure === 'other') {
        return otherMeasure;
      } else {
        switch (effectMeasure) {
          case 'SMD':
            return $.t('es:outcome.measure.translated.SMD');
          default:
            return '';
        }
      }
    },
    _contCorrespondingRisk: function(attributes) {
      var cif, cit, countable, effectSize, value, _ref;
      effectSize = attributes.effectSize;
      cif = attributes.confidenceIntervalFrom;
      cit = attributes.confidenceIntervalTo;
      countable = attributes.unitsType === "countable";
      if ((_ref = attributes._viewTypeName) === 'SOF_v4' || _ref === 'PrintoutSOFv4') {
        value = "" + (Number(effectSize)) + " ";
        value += " (" + (Number(cif)) + " ";
        value += $.t("es:outcome.to");
        value += " " + (Number(cit)) + ")";
      } else {
        value = "" + ($.t('es:outcome.the_mean')) + " " + (utils.uncapitalizeExceptAllCaps(attributes.name)) + " ";
        value += "" + ($.t('es:outcome.in_intervention_group_was')) + " ";
        value += "" + (numberToLocaleString(Number(Math.abs(effectSize)))) + " ";
        value += "" + (this._translateEffectMeasure(attributes.effectMeasure, attributes.otherMeasure)) + " ";
        if (attributes.units !== "") {
          value += " " + attributes.units + " ";
        }
        value += this._translateCountableUnitsType(effectSize, countable);
        value += " (" + (numberToLocaleString(Number(Math.abs(cif)))) + " ";
        value += this._translateCountableUnitsType(cif, countable);
        value += ' ';
        value += $.t("es:outcome.to");
        value += " " + (numberToLocaleString(Number(Math.abs(cit)))) + " ";
        value += this._translateCountableUnitsType(cit, countable);
        value += ')';
      }
      return "<span class='cell-value pt8'>" + value + "</span>";
    },
    dichCorrespondingRiskEditInfo: function(attributes, controlRiskLevel) {
      var a, absDenominator, cer, cr, from, to, val, value, _ref;
      a = attributes;
      cer = this._formatCerIfNaN((function() {
        switch (controlRiskLevel) {
          case 'calculatedControl':
            return statisticalUtils.getControlEventRate(attributes);
          default:
            return a["" + controlRiskLevel + "Risk"] / 100;
        }
      })());
      _ref = ((function() {
        var _i, _len, _ref, _results;
        _ref = [a.effectSize, a.confidenceIntervalFrom, a.confidenceIntervalTo];
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          val = _ref[_i];
          _results.push(this._multiplyByDenominator(statisticalUtils.calculateCorrespondingRisk(cer, val, a.effectMeasure, a.eventType), a.absDenominator));
        }
        return _results;
      }).call(this)).map(function(v) {
        return numberToLocaleString(Number(v));
      }), cr = _ref[0], from = _ref[1], to = _ref[2];
      value = _.string.capitalize($.t('es:outcome.corresponding_risk'));
      if (a.viewTypeName === "SOF" && a.metaType === "RANGE_OF_EFFECTS") {
        return value += " " + this._crRangeOfEffectSof(cer, a.effectSize, a.effectMeasure, a.confidenceIntervalFrom, a.confidenceIntervalTo, a.absDenominator, a.eventType);
      } else {
        absDenominator = numberToLocaleString(Number(a.absDenominator));
        return value += (" <b>" + cr + "</b> " + ($.t('es:outcome.per')) + " <b>" + absDenominator + "</b> " + ($.t('es:outcome.with')) + " <b>" + from + "</b> " + ($.t('es:outcome.to')) + " <b>" + to + "</b> ").toLowerCase() + $.t('es:outcome.confidence_interval');
      }
    },
    _crRangeOfEffectSof: function(cer, effectSize, effectMeasure, confidenceIntervalFrom, confidenceIntervalTo, absDenominator, eventType) {
      var cr;
      cr = "" + ($.t('es:outcome.ranged')) + " " + ($.t('es:outcome.from')) + " ";
      cr += this._multiplyByDenominator(statisticalUtils.calculateCorrespondingRisk(cer, confidenceIntervalFrom, effectMeasure, eventType), absDenominator);
      cr += " " + ($.t('es:outcome.to')) + " ";
      cr += this._multiplyByDenominator(statisticalUtils.calculateCorrespondingRisk(cer, confidenceIntervalTo, effectMeasure, eventType), absDenominator);
      return "<span class='cell-value'>" + cr + "</span>";
    },
    correspondingRisk: function(attributes) {
      var a, cer, _ref, _ref1, _ref2, _ref3;
      if ((_ref = attributes.type) === 'dich' || _ref === 'time_to_event') {
        cer = this._formatCerIfNaN(attributes.controlCount / attributes.controlTotal);
        a = attributes;
        if (((_ref1 = a._viewTypeName) != null ? _ref1.toLowerCase() : void 0) === "sof" && a.metaType === "RANGE_OF_EFFECTS") {
          return this._crRangeOfEffectSof(cer, a.effectSize, a.effectMeasure, a.confidenceIntervalFrom, a.confidenceIntervalTo, a.absDenominator, a.eventType);
        } else if ((_ref2 = (_ref3 = a._viewTypeName) != null ? _ref3.toLowerCase() : void 0) === "sof_v3" || _ref2 === "printoutsofv3") {
          return this._dichCorrespondingRiskPercent(cer, attributes);
        } else {
          return this._dichCorrespondingRisk(cer, attributes);
        }
      } else {
        return this._contCorrespondingRisk(attributes);
      }
    },
    _dichCorrespondingRiskForLevel: function(riskLevelValue, attributes, defaultCerName) {
      var a, cer, _ref, _ref1, _ref2;
      if (defaultCerName == null) {
        defaultCerName = '';
      }
      a = attributes;
      cer = riskLevelValue / 100;
      if (((_ref = a._viewTypeName) != null ? _ref.toLowerCase() : void 0) === "sof" && a.metaType === "RANGE_OF_EFFECTS") {
        return this._crRangeOfEffectSof(cer, a.effectSize, a.effectMeasure, a.confidenceIntervalFrom, a.confidenceIntervalTo, a.absDenominator, a.eventType);
      } else if ((_ref1 = (_ref2 = a._viewTypeName) != null ? _ref2.toLowerCase() : void 0) === "sof_v3" || _ref1 === "printoutsofv3") {
        return this._dichCorrespondingRiskPercent(cer, attributes, defaultCerName);
      } else {
        return this._dichCorrespondingRisk(cer, attributes, defaultCerName);
      }
    },
    correspondingRiskLow: function(attributes) {
      var value;
      value = this._dichCorrespondingRiskForLevel(attributes.lowControlRisk, attributes, 'Low');
      return value = "" + value;
    },
    correspondingRiskModerate: function(attributes) {
      var value;
      value = this._dichCorrespondingRiskForLevel(attributes.moderateControlRisk, attributes, 'Moderate');
      return value = "" + value;
    },
    correspondingRiskHigh: function(attributes) {
      var value;
      value = this._dichCorrespondingRiskForLevel(attributes.highControlRisk, attributes, 'High');
      return value = "" + value;
    },
    riskWithIntervention: function(attributes) {
      var changeScoreInControlsValue, effectSize, showFinalScoreInControls, units;
      showFinalScoreInControls = attributes.showFinalScoreInControls, effectSize = attributes.effectSize, changeScoreInControlsValue = attributes.changeScoreInControlsValue, units = attributes.units;
      if (showFinalScoreInControls && effectSize && changeScoreInControlsValue) {
        return "<b>" + (Number(changeScoreInControlsValue) + Number(effectSize)) + " " + units + "</b>";
      } else {
        return '-';
      }
    },
    _dichRiskDifference: function(attributes, defaultCerName) {
      var absDenominator, cer, confidenceIntervalFrom, confidenceIntervalTo, effectMeasure, effectSize, eventType, rd, rdFromVal, rdToVal, _ref;
      if (defaultCerName == null) {
        defaultCerName = '';
      }
      effectSize = attributes.effectSize, effectMeasure = attributes.effectMeasure, confidenceIntervalFrom = attributes.confidenceIntervalFrom, confidenceIntervalTo = attributes.confidenceIntervalTo, absDenominator = attributes.absDenominator, eventType = attributes.eventType;
      cer = defaultCerName === '' ? attributes.controlCount / attributes.controlTotal : attributes["" + (defaultCerName.toLowerCase()) + "ControlRisk"] / 100;
      rd = '<b>';
      rd += this._formatFewerMore(this._multiplyByDenominator(statisticalUtils.calculateRiskDifference(cer, effectSize, effectMeasure, eventType), absDenominator));
      rd += " " + ($.t('es:outcome.per'));
      rd += " " + (numberToLocaleString(absDenominator));
      rd += '</b><br>(';
      rdFromVal = statisticalUtils.calculateRiskDifference(cer, confidenceIntervalFrom, effectMeasure, eventType);
      rdToVal = statisticalUtils.calculateRiskDifference(cer, confidenceIntervalTo, effectMeasure, eventType);
      _ref = this._orderCIFromCITo(rdFromVal, rdToVal), rdFromVal = _ref[0], rdToVal = _ref[1];
      rd += this._formatFewerMore(this._multiplyByDenominator(rdFromVal, absDenominator));
      rd += " " + ($.t('es:outcome.to')) + " ";
      rd += this._formatFewerMore(this._multiplyByDenominator(rdToVal, absDenominator));
      rd += ')';
      return "<span class='cell-value'>" + rd + "</span>";
    },
    _getRiskDifferenceValues: function(attributes, defaultCerName) {
      var absDenominator, absEffectAutoCalc, absEffectFrom, absEffectSize, absEffectTo, cer, cerName, confidenceIntervalFrom, confidenceIntervalTo, effectMeasure, effectSize, eventType;
      if (defaultCerName == null) {
        defaultCerName = '';
      }
      cer = defaultCerName === '' ? attributes.controlCount / attributes.controlTotal : attributes["" + (defaultCerName.toLowerCase()) + "ControlRisk"] / 100;
      absEffectAutoCalc = attributes.absEffectAutoCalc, absDenominator = attributes.absDenominator, effectSize = attributes.effectSize, effectMeasure = attributes.effectMeasure, confidenceIntervalFrom = attributes.confidenceIntervalFrom, confidenceIntervalTo = attributes.confidenceIntervalTo, eventType = attributes.eventType;
      if (absEffectAutoCalc) {
        return [statisticalUtils.calculateRiskDifference(cer, effectSize, effectMeasure, eventType), statisticalUtils.calculateRiskDifference(cer, confidenceIntervalFrom, effectMeasure, eventType), statisticalUtils.calculateRiskDifference(cer, confidenceIntervalTo, effectMeasure, eventType)];
      } else {
        cerName = _.string.capitalize(defaultCerName);
        absEffectSize = attributes["absEffectSize" + cerName];
        absEffectFrom = attributes["absEffectFrom" + cerName];
        absEffectTo = attributes["absEffectTo" + cerName];
        return [utils.isNumeric(absEffectSize) ? Number(absEffectSize) / absDenominator : void 0, utils.isNumeric(absEffectFrom) ? Number(absEffectFrom) / absDenominator : void 0, utils.isNumeric(absEffectTo) ? Number(absEffectTo) / absDenominator : void 0];
      }
    },
    _dichRiskDifferencePercent: function(attributes, defaultCerName) {
      var absDenominator, absEffectAutoCalc, confidenceIntervalFrom, confidenceIntervalTo, effectMeasure, effectSize, eventType, rd, rdFromVal, rdSize, rdToVal, scale, _ref, _ref1;
      if (defaultCerName == null) {
        defaultCerName = '';
      }
      absEffectAutoCalc = attributes.absEffectAutoCalc, absDenominator = attributes.absDenominator, effectSize = attributes.effectSize, effectMeasure = attributes.effectMeasure, confidenceIntervalFrom = attributes.confidenceIntervalFrom, confidenceIntervalTo = attributes.confidenceIntervalTo, eventType = attributes.eventType;
      scale = 1;
      rd = '<b>';
      _ref = this._getRiskDifferenceValues(attributes, defaultCerName), rdSize = _ref[0], rdFromVal = _ref[1], rdToVal = _ref[2];
      _ref1 = this._orderCIFromCITo(rdFromVal, rdToVal), rdFromVal = _ref1[0], rdToVal = _ref1[1];
      rd += this._formatFewerMore(this._convertToPercentValue(rdSize), true, scale);
      rd += '</b><br>(';
      rd += this._formatFewerMore(this._convertToPercentValue(rdFromVal), true, scale);
      rd += " " + ($.t('es:outcome.to')) + " ";
      rd += this._formatFewerMore(this._convertToPercentValue(rdToVal), true, scale);
      rd += ')';
      return "<span class='cell-value'>" + rd + "</span>";
    },
    riskDifference: function(attributes) {
      var _ref, _ref1, _ref2;
      if ((_ref = attributes.type) === 'dich' || _ref === 'time_to_event') {
        if ((_ref1 = (_ref2 = attributes._viewTypeName) != null ? _ref2.toLowerCase() : void 0) === "sof_v3" || _ref1 === "printoutsofv3") {
          return this._dichRiskDifferencePercent(attributes);
        } else {
          return this._dichRiskDifference(attributes);
        }
      } else {
        return this._contAbsoluteEffect(attributes);
      }
    },
    riskDifferenceLow: function(attributes) {
      var value;
      value = this._dichRiskDifferenceForLevel(attributes, 'low');
      return "" + value;
    },
    riskDifferenceModerate: function(attributes) {
      var value;
      value = this._dichRiskDifferenceForLevel(attributes, 'moderate');
      return "" + value;
    },
    riskDifferenceHigh: function(attributes) {
      var value;
      value = this._dichRiskDifferenceForLevel(attributes, 'high');
      return "" + value;
    },
    _dichRiskDifferenceForLevel: function(attributes, defaultCerName) {
      var _ref, _ref1;
      if (defaultCerName == null) {
        defaultCerName = '';
      }
      if ((_ref = (_ref1 = attributes._viewTypeName) != null ? _ref1.toLowerCase() : void 0) === "sof_v3" || _ref === "printoutsofv3") {
        return this._dichRiskDifferencePercent(attributes, defaultCerName);
      } else {
        return this._dichRiskDifference(attributes, defaultCerName);
      }
    },
    noOfParticipantsStudiesFollowUp: function(attributes) {
      var designStudy, participants, studies;
      designStudy = formatters._getDesignStudy(attributes.designStudies);
      studies = this._formatDesignStudiesForACCPandSoF(attributes.noOfStudies, attributes.designStudies);
      participants = attributes._viewTypeName === 'ACCP' && OutcomesHelper.isCaseControlType(designStudy) ? '' : "" + (this._noOfParticipantsStudies(attributes)) + "<br>";
      participants += studies;
      if (attributes._viewTypeName !== "ACCP") {
        return participants;
      }
      if (attributes.followUpLength && attributes.followUpTimeUnit) {
        participants += "<br>" + (this._followUpOrTiming(attributes));
      }
      return participants;
    },
    _formatDesignStudiesForACCPandSoF: function(noOfStudies, designStudies) {
      var count, label, labelKey;
      if (designStudies == null) {
        designStudies = '';
      }
      labelKey = !designStudies.name ? 'study' : designStudies.name === 'RandTrials' ? 'rct' : designStudies.name === 'NonRandStudy' ? 'non_randomised_studies' : designStudies.name === 'ObsStudies' ? 'observational_studies' : designStudies.name === 'SingleArm' ? 'single_arm_trials' : void 0;
      count = !noOfStudies ? 0 : noOfStudies;
      label = $.t('es:outcome.' + labelKey, {
        count: count
      });
      return "(" + noOfStudies + " " + label + ")";
    },
    eventRatesWithControl: function(attributes) {
      return this._interventionsAndComparisions(attributes, 'control');
    },
    eventRatesWithIntervention: function(attributes) {
      return this._interventionsAndComparisions(attributes, 'intervention');
    },
    effectCount: function(attributes) {
      return attributes.effectCount;
    },
    effectTotal: function(attributes) {
      return attributes.effectTotal;
    },
    effectRate: function(attributes) {
      var _ref;
      if (!attributes.effectRate) {
        return "";
      }
      if ((_ref = attributes.type) === 'dich' || _ref === 'time_to_event') {
        return this._dichEffectRate(attributes);
      } else if (attributes.type === 'cont') {
        return this._contEffectRate(attributes);
      }
    },
    _contEffectRate: function(attributes) {
      var val;
      if (!attributes.effectMeasure) {
        return "";
      }
      val = "" + (this._attrWithOtherValue(attributes, 'effectMeasure', 'otherMeasure')) + " ";
      val += attributes.effectRate;
      val += " " + attributes.units;
      val += " (";
      val += formatters._formatNulls(attributes.confidenceIntervalFrom);
      val += " " + ($.t('es:outcome.to')) + " ";
      val += formatters._formatNulls(attributes.confidenceIntervalTo);
      return val += ")";
    },
    _dichEffectRate: function(attr) {
      var val, _getEffectOtherValues;
      _getEffectOtherValues = function(effect, other) {
        if (!effect) {
          return "";
        }
        if (effect === 'other') {
          return other;
        } else {
          if ($.isNumeric(effect)) {
            return effect;
          } else {
            return $.t("es:outcome." + effect);
          }
        }
      };
      val = "" + ($.t('es:outcome.event_rate')) + "<br>";
      if (!attr.effectDenominator) {
        val += "" + (this.percentValue(attr.effectRate)) + " ";
      } else {
        val += "" + attr.effectRate + " ";
        val += "" + ($.t('es:outcome.per')) + " ";
        val += "" + (_getEffectOtherValues(attr.effectDenominator, attr.effectOtherDenominator));
        val += " " + (_getEffectOtherValues(attr.effectDuration, attr.effectOtherDuration)) + " ";
      }
      val += " (";
      val += formatters._formatNulls(attr.confidenceIntervalFrom);
      val += " " + ($.t('es:outcome.to')) + " ";
      val += formatters._formatNulls(attr.confidenceIntervalTo);
      return val += ")";
    }
  },
  question: {
    _pooledSenSpec: function(isRange, val, valFrom, valTo) {
      var format;
      format = function(v) {
        return formatters._toFixedNumber(formatters._formatNulls(v));
      };
      if (isRange) {
        return "" + (format(valFrom)) + " " + ($.t('es:outcome.to')) + " " + (format(valTo));
      } else {
        return "" + (format(val)) + " (95% CI: " + (format(valFrom)) + " " + ($.t('es:outcome.to')) + " " + (format(valTo)) + ")";
      }
    },
    _sensSpecAttrName: function(attrSuffix, sensitivity, comparatorTest) {
      var comparison, sensSpec;
      sensSpec = sensitivity ? 'Sensitivity' : 'Specificity';
      comparison = comparatorTest ? 'Comparison' : '';
      return "pooled" + sensSpec + comparison + attrSuffix;
    },
    sensitivitySpecificity: function(data, sensitivity, comparatorTest) {
      var isRange, val, valFrom, valTo;
      isRange = data.sourceOfDxData === 'rangeFromStudies';
      if (isRange) {
        valFrom = data[this._sensSpecAttrName('RangeFrom', sensitivity, comparatorTest)];
        valTo = data[this._sensSpecAttrName('RangeTo', sensitivity, comparatorTest)];
      } else {
        val = data[this._sensSpecAttrName('', sensitivity, comparatorTest)];
        valFrom = data[this._sensSpecAttrName('From', sensitivity, comparatorTest)];
        valTo = data[this._sensSpecAttrName('To', sensitivity, comparatorTest)];
      }
      return this._pooledSenSpec(isRange, val, valFrom, valTo);
    }
  }
};

module.exports = formatters;
